var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBed = function SvgBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24292D",
    d: "M1 3.5a.5.5 0 0 1 1 0v1.017a1.32 1.32 0 0 1 .34-.044h1.494a1.34 1.34 0 0 1 1.255 1.813h8.562c.822 0 1.49.667 1.49 1.49v3.944a.5.5 0 0 1-.5.5h-1.194v.534a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.492-.41l-.008-.09v-.534H5.349a.5.5 0 0 1-.5-.5l-.001-.11H3.557v1.145a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.491-.41l-.008-.09-.001-1.145H1.5a.5.5 0 0 1-.492-.41L1 11.11zm12.65 3.785h-7.8l-.001 1.63v2.305h8.293V7.775a.49.49 0 0 0-.49-.49zm-8.802 2.14L2 9.428v1.184l2.848-.001V9.426zm0-2.14H2v1.141h2.848V7.285zM3.834 5.473H2.34a.34.34 0 1 0 0 .68h1.493a.34.34 0 1 0 0-.68z"
  })));
};
export default SvgBed;